import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { DocumentPreview } from '@/components/FileManager/Preview/types/PreviewTypes'
import { MainService } from '@/services/MainService'
import { convertEmailSentDateToLocal } from '@/helpers/dateTime'
import ClosePreviewComponent from '@/components/FileManager/Preview/components/ClosePreviewComponent.vue'
import SpinnerLayer from '@/components/Spinner/SpinnerLayerComponent.vue'

// DATA

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailPreviewComponent',
  emits: ['close-viewer-event', 'failPreview'],
  setup(__props, { expose, emit }) {

const htmlContent = ref('')
const loading = ref(true)

// EVENTS


// METHODS
function closeViewerEvent() {
  emit('close-viewer-event')
}

function onServiceFailure() {
  emit('failPreview')
}

async function fetchEmailHTMLTemplate(documentId: number) {
  const url = `/v2/document/${documentId}/email-to-html`
  const { data } = await new MainService().getData(url)
  htmlContent.value = convertEmailSentDateToLocal(data.htmlContent)
}

async function preview(documentPreview: DocumentPreview) {
  try {
    loading.value = true
    const { id } = documentPreview
    await fetchEmailHTMLTemplate(id)
  } catch (error) {
    return onServiceFailure()
  } finally {
    loading.value = false
  }
}

expose({
  preview
})

return { __sfc: true,htmlContent, loading, emit, closeViewerEvent, onServiceFailure, fetchEmailHTMLTemplate, preview, ClosePreviewComponent, SpinnerLayer }
}

})